import gql from 'graphql-tag';

export const CART_SUBSCRIPTION_FRAGMENT = gql`
  fragment SubscriptionDetails on Cart {
    subscriptionDetails {
      __typename
      initialPaymentInfo {
        __typename
        setupFee {
          __typename
          currencyCode
          currencyFormat
          currencyFormatSymbolISOCurrency
          currencyValue
        }
        firstPayment {
          __typename
          currencyCode
          currencyFormat
          currencyFormatSymbolISOCurrency
          currencyValue
        }
        shippingAmount {
          __typename
          currencyCode
          currencyFormat
          currencyFormatSymbolISOCurrency
          currencyValue
        }
        taxPercentage
        totalAmount {
          __typename
          currencyCode
          currencyFormat
          currencyFormatSymbolISOCurrency
          currencyValue
        }
      }
      plan {
        __typename
        id
        name
        billingCycles {
          __typename
          fixedPrice {
            __typename
            currencyCode
            currencyFormat
            currencyFormatSymbolISOCurrency
            currencyValue
          }
          frequency {
            __typename
            intervalUnit
            intervalCount
          }
          totalCycles
        }
        startTime
      }
    }
  }
`;
